import Alpine from 'alpinejs/dist/module.cjs'
const data = (params = {}) => ({
  checked: [],
  enabledFilter: false,
  expanded: [],
  get tdColspanCounts() {
    return this.enabledFilter ? this.checkedTds : this.checked.length
  },
  get checkedTds() {
    return this.checked.filter((v) => v).length
  },
  get arrowPosition() {
    if (this.isPC) {
      return this.tdColspanCounts === 5 ? 'right-8' : 'right-4'
    } else {
      /* eslint-disable */
      this.tdColspanCounts
      /* eslint-enable */
      return 'right-4'
    }
  },
  async init() {
    await this.$nextTick()
    this.checked = new Array(
      this.$root.querySelectorAll('tr:first-child > td').length
    ).fill(false)
  },
  async isArrowContainerOverflow() {
    if (this.isPC) {
      return this.tdColspanCounts < 5
    } else {
      /* eslint-disable */
      this.tdColspanCounts
      /* eslint-enable */
      await this.$nextTick()
      const viewWidth = window.innerWidth
      const tableWidth = this.$root.offsetWidth
      return viewWidth > tableWidth
    }
  },

  ...params,
})

Alpine.data('simulationTable', data)
